import { getCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import type {
  BrandConcessionSectionProductDM,
  MultiSectionFigmaLayout,
  SectionItemDM,
} from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/MultiSectionView.types';
import type { ViewData } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/multisection.data';
import {
  PRODUCT_SUBTITLE_HEIGHT,
  PRODUCT_SUBTITLE_MARGIN_TOP,
} from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/shelf/common/shelfDisplay.figma';

type GetProductTitleCardParams = {
  product: BrandConcessionSectionProductDM;
  viewData: ViewData;
  layout: MultiSectionFigmaLayout;
  section?: SectionItemDM;
};

export function getProductTitleCard({
  product,
  viewData,
  layout,
  section,
}: GetProductTitleCardParams) {
  const card = getCard<PlaneTypes.Card_MultiSection_Subtitle>({
    type: PlaneTypes.Card_MultiSection_Subtitle,
    size: { width: viewData.columnWidth!, height: PRODUCT_SUBTITLE_HEIGHT },
    data: {
      style: {
        color: section?.fontColour,
      },
      id: product.id.toString(),
      key: [
        'brandConcession',
        viewData.modelData.concessionId,
        'sectionId',
        section?.id,
        'title',
        product.id,
      ].join('-'),
      title: product.name,
      type: undefined,
      layout,
    },
  });

  card.key = card.data?.key;

  return card;
}

export function getProductCard(
  product: BrandConcessionSectionProductDM,
  viewData: ViewData,
  parentSectionId?: number
) {
  const card = getCard<PlaneTypes.Card_MultiSection_Product>({
    type: PlaneTypes.Card_MultiSection_Product,
    size: { width: viewData.columnWidth!, height: viewData.columnWidth! },
    data: {
      id: product.id.toString(),
      key: [
        'brandConcession',
        viewData.modelData.concessionId,
        'sectionId',
        parentSectionId,
        'product',
        product.id,
      ].join('-'),
      imageUrl: product.imageUrl,
      product,
      type: undefined,
      sectionId: parentSectionId,
    },
  });

  card.key = card.data?.key;

  return card;
}

export function getProductEquivalentHeight(viewData: ViewData) {
  return (
    viewData.columnWidth! +
    PRODUCT_SUBTITLE_HEIGHT +
    PRODUCT_SUBTITLE_MARGIN_TOP
  );
}
